export const environment = {
  production: true,
  mobile: false,
};
